import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { FormattedRpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration";
import { ActiveAcuantPropertyFlags } from "@idw-types/common/active-acuant-property-flags";
import { isNullOrUndefined } from "./object-util";
import { ThemingOriginTypes } from "@enums/theming-origin-types";
import { PageLevelTypes } from "@enums/page-level-types";

export const getActiveAcuantProperties = (properties: Array<FormattedRpServiceConfigurationProperty>) => {
    const finalAcuantPropertyValidation: ActiveAcuantPropertyFlags = {
        hasValidAcuantDPIValidationProperty: false,
        hasValidAcuantGlareValidationProperty: false,
        hasValidAcuantSharpnessValidationProperty: false,
        hasValidAcuantSDKCaptureProperty: false,
        hasValidLivenessApikey: false
    };

    properties.forEach((property) => {
        if (property.shortName === "useAcuantSDKDPIValidation" && isStringTrue(property.value)) {
            finalAcuantPropertyValidation.hasValidAcuantDPIValidationProperty = true;
        }

        if (property.shortName === "useAcuantSDKGlareValidation" && isStringTrue(property.value)) {
            finalAcuantPropertyValidation.hasValidAcuantGlareValidationProperty = true
        }

        if (property.shortName === "useAcuantSDKSharpnessValidation" && isStringTrue(property.value)) {
            finalAcuantPropertyValidation.hasValidAcuantSharpnessValidationProperty = true;
        }
        if (property.shortName === "useAcuantSDKCapture" && isStringTrue(property.value)) {
            finalAcuantPropertyValidation.hasValidAcuantSDKCaptureProperty = true;
        }
        if (property.shortName === "livenessApikey" && !isNullOrUndefined(property.value) && isStringTrue(`${property.addedToService}`)) {
            finalAcuantPropertyValidation.hasValidLivenessApikey = true;
        }
    });

    return finalAcuantPropertyValidation;
};

export const getThemingPropertyValueOrigin = (
    inheritedValue: string | boolean,
    currentValue: string | boolean,
    pageLevel: PageLevelTypes
) => {
    if (pageLevel === PageLevelTypes.APIKEY) {
        return (inheritedValue === currentValue) ? ThemingOriginTypes.INHERITED : ThemingOriginTypes.OVERRIDDEN;
    } else {
        return (inheritedValue === currentValue) ? ThemingOriginTypes.DEFAULT : ThemingOriginTypes.OVERRIDDEN;
    }
}